type TimezoneLabel = { from: number; short: string; long: string };

// BC, Alberta, the Northwest Territories and Manitoba stopped changing clocks on
// 2026-11-01. tzdata and CLDR label the fixed offsets inconsistently (MST, PST or
// PDT depending on the browser), so keep the daylight-time label they adopted.
// Mirrored in the backend (app/timezone_labels.py); keep both in sync.
const PACIFIC: TimezoneLabel = {
  from: Date.UTC(2026, 10, 1, 9),
  short: 'PDT',
  long: 'Pacific Daylight Time'
};
const MOUNTAIN: TimezoneLabel = {
  from: Date.UTC(2026, 10, 1, 8),
  short: 'MDT',
  long: 'Mountain Daylight Time'
};
const CENTRAL: TimezoneLabel = {
  from: Date.UTC(2026, 10, 1, 7),
  short: 'CDT',
  long: 'Central Daylight Time'
};

const PERMANENT_DAYLIGHT_ZONES: Record<string, TimezoneLabel> = {
  'America/Vancouver': PACIFIC,
  'Canada/Pacific': PACIFIC,
  'America/Edmonton': MOUNTAIN,
  'America/Yellowknife': MOUNTAIN,
  'America/Inuvik': MOUNTAIN,
  'Canada/Mountain': MOUNTAIN,
  'America/Winnipeg': CENTRAL,
  'America/Rainy_River': CENTRAL,
  'Canada/Central': CENTRAL
};

export const PERMANENT_DAYLIGHT_OFFSETS_MINUTES: Record<string, number> = {
  'America/Vancouver': -420,
  'America/Edmonton': -360,
  'America/Winnipeg': -300
};

export const getPermanentDaylightLabel = (
  timezoneCode: string,
  instant: number,
  type: 'short' | 'long' = 'short'
): string | undefined => {
  const zone = PERMANENT_DAYLIGHT_ZONES[timezoneCode];
  if (!zone || instant < zone.from) {
    return undefined;
  }
  return type === 'long' ? zone.long : zone.short;
};
